var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightDoubleArrowEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#32325D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 1.41L6 0 0 6 6 12 7.41 10.59 2.83 6z",
    transform: "matrix(-1 0 0 1 19 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41 1.41L11 0 5 6 11 12 12.41 10.59 7.83 6z",
    transform: "matrix(-1 0 0 1 19 6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDoubleArrowEnabled);
export default __webpack_public_path__ + "static/media/right_double_arrow_enabled.bc8c63341a5f417d77a5cbef4adbf789.svg";
export { ForwardRef as ReactComponent };